import {
  zoomTransform,
  select,
  event,
  format,
  timeFormat,
  line as lineD3,
  area as areaD3,
} from "d3";
import {
  grayLightBackground,
  textactive2,
} from "@/_core/_helpers/_parametric_tools";
import {
  dotCreate,
  hLineCreate,
  vLineCreate,
} from "@/_core/charts/D3ChartHoverHelpers";
import {
  createTooltips,
  displayDataTA,
  inRange,
  mouseDate,
  roundDate,
  zoomSetup,
} from "@/_core/charts/TechnicalAnalysis";

export function RSIHover(_this, upColor, colorTheme) {
  const auxName = "RSI";
  let valueLast = _this.candleData[_this.candleData.length - 1].rsi;
  let xTooltipWidth = 80;
  let yTooltip = createTooltips(
    _this.svgNodeRSI,
    _this.currencyFormat,
    valueLast,
    xTooltipWidth,
    _this.colorTheme,
    auxName,
  );
  let lastYTooltip = yTooltip["lastTooltip"];
  _this.svgNodeRSI.lastYTooltip = lastYTooltip;
  let xTooltip = yTooltip["xTooltip"];
  yTooltip = yTooltip["yTooltip"];
  hLineCreate(
    _this.svgNodeRSI,
    auxName + _this.chartName,
    grayLightBackground(colorTheme),
    1,
  );
  vLineCreate(
    _this.svgNodeRSI,
    auxName + _this.chartName,
    grayLightBackground(colorTheme),
    1,
  );
  dotCreate(
    _this.svgNodeRSI,
    auxName + _this.chartName,
    3.5,
    textactive2(colorTheme),
    upColor,
    2,
  );

  function mouseover() {
    if (_this.transform === undefined || _this.transform == null) {
      _this.transform = zoomTransform(
        select(".hoverParent" + auxName + _this.chartName)._groups[0][0],
      );
    }
    event.preventDefault();
    const xPixels = Math.max(
      Math.min(
        event.layerX - _this.svgNodeRSI.margin.left,
        _this.svgNodeRSI.width,
      ),
      0,
    );
    var xt = _this.transform.rescaleX(_this.svgNodeRSI.x);
    var yt = _this.svgNodeRSI.y;
    let dat = roundDate(xt.invert(xPixels));
    let selData;

    let highlightCandles = true;
    if (dat <= _this.candleData[_this.candleData.length - 1].date) {
      selData = mouseDate(xt.invert(xPixels), _this.candleData);
    } else {
      selData = JSON.parse(
        JSON.stringify(_this.candleData[_this.candleData.length - 1]),
      );
      selData["date"] = dat;
      highlightCandles = false;
    }
    const yPixels = Math.max(
      Math.min(
        event.layerY - _this.svgNodeRSI.margin.top,
        _this.svgNodeRSI.height,
      ),
      0,
    );
    let yRate = yt.invert(yPixels);
    yTooltip
      .style("opacity", 1)
      .style(
        "left",
        _this.svgNodeRSI.width + _this.svgNodeRSI.margin.left + 1 + "px",
      )
      .style("top", yPixels + _this.svgNodeRSI.margin.top - 11 + "px")
      .html(format(_this.currencyFormat)(yRate));

    xTooltip
      .style("opacity", 1)
      .style(
        "left",
        xt(selData.date) +
          _this.svgNodeRSI.margin.left -
          xTooltipWidth / 2 +
          "px",
      )
      .style(
        "top",
        _this.svgNodeRSI.height + _this.svgNodeRSI.margin.top + 2 + "px",
      )
      .html(timeFormat(_this.dateFormat)(selData.date));

    select(".hHoverLineRSI" + _this.chartName)
      .style("opacity", 1)
      .attr("y1", yPixels)
      .attr("y2", yPixels);

    let xPix = xt(selData.date);

    select(".vHoverLineTA" + _this.chartName)
      .style("opacity", 1)
      .attr("x1", xPix)
      .attr("x2", xPix);
    select(".vHoverLineRSI" + _this.chartName)
      .style("opacity", 1)
      .attr("x1", xPix)
      .attr("x2", xPix);
    if (_this.showMACD === true) {
      select(".vHoverLineMACD" + _this.chartName)
        .style("opacity", 1)
        .attr("x1", xPix)
        .attr("x2", xPix);
    }
    if (_this.showSTOCH === true) {
      select(".vHoverLineSTOCH" + _this.chartName)
        .style("opacity", 1)
        .attr("x1", xPix)
        .attr("x2", xPix);
    }

    if (highlightCandles) {
      let bandWidth = _this.transform.k * _this.bandWidth;
      const candleWidth = bandWidth * _this.barWidth + 1;
      const yt2 = _this.svgNode.y;
      if (_this.isCandles) {
        let up = Math.max(selData.open, selData.close);
        let dn = Math.min(selData.open, selData.close);
        select(".cndlStckTA" + _this.chartName)
          .style("opacity", 1)
          .attr("x1", xPix)
          .attr("x2", xPix)
          .attr("y1", yt2(selData.high))
          .attr("y2", yt2(up));
        select(".cndlStck2TA" + _this.chartName)
          .style("opacity", 1)
          .attr("x1", xPix)
          .attr("x2", xPix)
          .attr("y1", yt2(dn))
          .attr("y2", yt2(selData.low));
        select(".cndlTA" + _this.chartName)
          .style("opacity", 1)
          .attr("x", xPix - candleWidth / 2)
          .attr("y", yt2(up))
          .attr("height", Math.max(1, yt2(dn) - yt2(up)))
          .attr("width", candleWidth);
      } else {
        select(".dotTA" + _this.chartName)
          .style("opacity", 1)
          .attr(
            "transform",
            `translate(${xt(selData.date)},${yt2(selData.close)})`,
          );
      }
      select(".dotRSI" + _this.chartName)
        .style("opacity", 1)
        .attr("transform", `translate(${xt(selData.date)},${yt(selData.rsi)})`);
      if (_this.showMACD === true) {
        const yt3 = _this.svgNodeMACD.y;
        select(".dotMACD" + _this.chartName)
          .style("opacity", 1)
          .attr(
            "transform",
            `translate(${xt(selData.date)},${yt3(selData.macd)})`,
          );
        select(".dotMACDSignal" + _this.chartName)
          .style("opacity", 1)
          .attr(
            "transform",
            `translate(${xt(selData.date)},${yt3(selData.macdSignal)})`,
          );
        select(".barMACDHistogram" + _this.chartName)
          .style("opacity", 1)
          .attr("x", xPix - candleWidth / 2)
          .attr("y", Math.min(yt3(0), yt3(selData["macdHist"])))
          .attr(
            "height",
            Math.max(1, Math.abs(yt3(0) - yt3(selData["macdHist"]))),
          )
          .attr("width", candleWidth);
      }
      if (_this.showSTOCH === true) {
        const yt4 = _this.svgNodeSTOCH.y;
        select(".dotStochPK" + _this.chartName)
          .style("opacity", 1)
          .attr(
            "transform",
            `translate(${xt(selData.date)},${yt4(selData.stochPK)})`,
          );
        select(".dotStochPD" + _this.chartName)
          .style("opacity", 1)
          .attr(
            "transform",
            `translate(${xt(selData.date)},${yt4(selData.stochPD)})`,
          );
      }
    } else {
      if (_this.isCandles) {
        select(".cndlStckTA" + _this.chartName).style("opacity", 0);
        select(".cndlStck2TA" + _this.chartName).style("opacity", 0);
        select(".cndlTA" + _this.chartName).style("opacity", 0);
      } else {
        select(".dotTA" + _this.chartName).style("opacity", 0);
      }
      select(".dotRSI" + _this.chartName).style("opacity", 0);
      if (_this.showMACD === true) {
        select(".barMACDHistogram" + _this.chartName).style("opacity", 0);
        select(".dotMACD" + _this.chartName).style("opacity", 0);
        select(".dotMACDSignal" + _this.chartName).style("opacity", 0);
      }
      if (_this.showSTOCH === true) {
        select(".dotStochPK" + _this.chartName).style("opacity", 0);
        select(".dotStochPD" + _this.chartName).style("opacity", 0);
      }
    }

    displayDataTA(selData, _this);
  }
  function mouseout() {
    yTooltip
      .style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");
    xTooltip
      .style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");
    select(".vHoverLineTA" + _this.chartName).style("opacity", 0);
    if (_this.isCandles) {
      select(".cndlStckTA" + _this.chartName).style("opacity", 0);
      select(".cndlStck2TA" + _this.chartName).style("opacity", 0);
      select(".cndlTA" + _this.chartName).style("opacity", 0);
    } else {
      select(".dotTA" + _this.chartName).style("opacity", 0);
    }
    select(".hHoverLineRSI" + _this.chartName).style("opacity", 0);
    select(".vHoverLineRSI" + _this.chartName).style("opacity", 0);
    select(".dotRSI" + _this.chartName).style("opacity", 0);
    if (_this.showMACD === true) {
      select(".barMACDHistogram" + _this.chartName).style("opacity", 0);
      select(".vHoverLineMACD" + _this.chartName).style("opacity", 0);
      select(".dotMACD" + _this.chartName).style("opacity", 0);
      select(".dotMACDSignal" + _this.chartName).style("opacity", 0);
    }
    if (_this.showSTOCH === true) {
      select(".vHoverLineSTOCH" + _this.chartName).style("opacity", 0);
      select(".dotStochPK" + _this.chartName).style("opacity", 0);
      select(".dotStochPD" + _this.chartName).style("opacity", 0);
    }
    displayDataTA(_this.candleData[_this.candleData.length - 1], _this);
  }
  function zoomed() {
    if (!_this.keepDateInterval) {
      setTimeout(() => {
        _this.pickedDateInterval = "-1";
      }, 500);
    }
    yTooltip
      .style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");
    xTooltip
      .style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");

    select(".vHoverLineTA" + _this.chartName).style("opacity", 0);
    if (_this.isCandles) {
      select(".cndlStckTA" + _this.chartName).style("opacity", 0);
      select(".cndlStck2TA" + _this.chartName).style("opacity", 0);
      select(".cndlTA" + _this.chartName).style("opacity", 0);
    } else {
      select(".dotTA" + _this.chartName).style("opacity", 0);
    }
    select(".hHoverLineRSI" + _this.chartName).style("opacity", 0);
    select(".vHoverLineRSI" + _this.chartName).style("opacity", 0);
    select(".dotRSI" + _this.chartName).style("opacity", 0);
    if (_this.showMACD === true) {
      select(".barMACDHistogram" + _this.chartName).style("opacity", 0);
      select(".vHoverLineMACD" + _this.chartName).style("opacity", 0);
      select(".dotMACD" + _this.chartName).style("opacity", 0);
      select(".dotMACDSignal" + _this.chartName).style("opacity", 0);
    }
    if (_this.showSTOCH === true) {
      select(".vHoverLineSTOCH" + _this.chartName).style("opacity", 0);
      select(".dotStochPK" + _this.chartName).style("opacity", 0);
      select(".dotStochPD" + _this.chartName).style("opacity", 0);
    }

    _this.transform = event.transform;
    _this.svgNodeRSI.gX.call(
      _this.svgNodeRSI.xAxis.scale(
        _this.transform.rescaleX(_this.svgNodeRSI.x),
      ),
    );
    const xt = _this.transform.rescaleX(_this.svgNodeRSI.x);
    RSIZooming(_this.transform, xt, _this);

    // transform other charts
    if (_this.externalZoom === false) {
      _this.externalZoom = true;
      select(".hoverParentTA" + _this.chartName).call(
        _this.zoomTA.transform,
        _this.transform,
      );
      if (_this.showMACD) {
        select(".hoverParentMACD" + _this.chartName).call(
          _this.zoomMACD.transform,
          _this.transform,
        );
      }
      if (_this.showSTOCH) {
        select(".hoverParentSTOCH" + _this.chartName).call(
          _this.zoomSTOCH.transform,
          _this.transform,
        );
      }
      _this.externalZoom = false;
    }
  }
  function zoomEnd() {
    _this.transform = event.transform;
    const xt = _this.transform.rescaleX(_this.svgNodeRSI.x);
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      var xmin = new Date(xt.invert(0));
      var xmax = new Date(xt.invert(_this.svgNodeRSI.width));

      if (!_this.externalZoom) {
        let data = _this.candleData.map((d) => d);
        _this.filteredData = data.filter(function(d) {
          return inRange(d.date, xmin, xmax);
        });
      }

      let yt = _this.svgNodeRSI.y;
      RSIZoomEnd(
        _this.transform,
        xt,
        yt,
        _this.filteredData,
        _this,
        lastYTooltip,
        valueLast,
      );
    }, 200);
  }

  var resizeTimer;
  zoomSetup(
    _this,
    "svgNode" + auxName,
    "zoom" + auxName,
    auxName,
    _this.chartName,
    mouseover,
    mouseout,
    zoomed,
    zoomEnd,
  );
}

export function RSIZooming(t, xt, _this) {
  let area, line, fieldName;
  // rsi
  if (_this.showRSI === true) {
    fieldName = "rsi";
    line = lineD3()
      .defined((d) => !Number.isNaN(d[fieldName]))
      .x((d) => xt(d.date))
      .y((d) => _this.svgNodeRSI.y(d[fieldName]));
    _this.svgNodeRSI["upperLineRSI" + _this.chartName].attr("d", (d) =>
      line(d),
    );
    fieldName = "rsi50";
    line = lineD3()
      .defined((d) => !Number.isNaN(d[fieldName]))
      .x((d) => xt(d.date))
      .y((d) => _this.svgNodeRSI.y(d[fieldName]));
    _this.svgNodeRSI["lowerLineRSI" + _this.chartName].attr("d", (d) =>
      line(d),
    );
    area = areaD3()
      .defined((d) => !Number.isNaN(d["rsi"]))
      .defined((d) => !Number.isNaN(d["rsi70"]))
      .x((d) => xt(d.date))
      .y0((d) => _this.svgNodeRSI.y(d["rsi"]))
      .y1((d) => _this.svgNodeRSI.y(d["rsi70"]));
    _this.svgNodeRSI["areaOSoldRSI" + _this.chartName].attr("d", area);
    area = areaD3()
      .defined((d) => !Number.isNaN(d["rsi"]))
      .defined((d) => !Number.isNaN(d["rsi30"]))
      .x((d) => xt(d.date))
      .y0((d) => _this.svgNodeRSI.y(d["rsi"]))
      .y1((d) => _this.svgNodeRSI.y(d["rsi30"]));
    _this.svgNodeRSI["areaOBoughtRSI" + _this.chartName].attr("d", area);
    area = areaD3()
      .defined((d) => !Number.isNaN(d["rsi"]))
      .defined((d) => !Number.isNaN(d["rsi50"]))
      .x((d) => xt(d.date))
      .y0((d) => _this.svgNodeRSI.y(d["rsi"]))
      .y1((d) => _this.svgNodeRSI.y(d["rsi50"]));
    _this.svgNodeRSI["areaRSI" + _this.chartName].attr("d", area);
  }
}

export function RSIZoomEnd(
  t,
  xt,
  yt,
  filtered,
  _this,
  lastYTooltip,
  valueLast,
) {
  let line, area, fieldName;
  // rsi
  if (_this.showRSI === true) {
    fieldName = "rsi";
    line = lineD3()
      .defined((d) => !Number.isNaN(d[fieldName]))
      .x((d) => xt(d.date))
      .y((d) => _this.svgNodeRSI.y(d[fieldName]));
    _this.svgNodeRSI["upperLineRSI" + _this.chartName]
      .data([filtered])
      .join("path")
      .attr("d", (d) => line(d));
    fieldName = "rsi50";
    line = lineD3()
      .defined((d) => !Number.isNaN(d[fieldName]))
      .x((d) => xt(d.date))
      .y((d) => _this.svgNodeRSI.y(d[fieldName]));
    _this.svgNodeRSI["lowerLineRSI" + _this.chartName]
      .data([filtered])
      .join("path")
      .attr("d", (d) => line(d));
    area = areaD3()
      .defined((d) => !Number.isNaN(d["rsi"]))
      .defined((d) => !Number.isNaN(d["rsi70"]))
      .x((d) => xt(d.date))
      .y0((d) => _this.svgNodeRSI.y(d["rsi"]))
      .y1((d) => _this.svgNodeRSI.y(d["rsi70"]));
    _this.svgNodeRSI["areaOSoldRSI" + _this.chartName]
      .data([filtered])
      .join("path")
      .attr("d", area);
    area = areaD3()
      .defined((d) => !Number.isNaN(d["rsi"]))
      .defined((d) => !Number.isNaN(d["rsi30"]))
      .x((d) => xt(d.date))
      .y0((d) => _this.svgNodeRSI.y(d["rsi"]))
      .y1((d) => _this.svgNodeRSI.y(d["rsi30"]));
    _this.svgNodeRSI["areaOBoughtRSI" + _this.chartName]
      .data([filtered])
      .join("path")
      .attr("d", area);
    area = areaD3()
      .defined((d) => !Number.isNaN(d["rsi"]))
      .defined((d) => !Number.isNaN(d["rsi50"]))
      .x((d) => xt(d.date))
      .y0((d) => _this.svgNodeRSI.y(d["rsi"]))
      .y1((d) => _this.svgNodeRSI.y(d["rsi50"]));
    _this.svgNodeRSI["areaRSI" + _this.chartName]
      .data([filtered])
      .join("path")
      .attr("d", area);

    // last rate
    var yMax = yt.invert(0);
    var yMin = yt.invert(_this.svgNodeRSI.height);
    lastYTooltip
      .html(format(_this.currencyFormat)(valueLast))
      .transition()
      .duration(500)
      .style("opacity", yMin <= valueLast && valueLast <= yMax ? 1 : 0)
      .style("top", yt(valueLast) + _this.svgNodeRSI.margin.top - 11 + "px");
  }
}
